import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './Button';
import { Logo } from './Logo';
import { useNavigate } from 'react-router-dom';

export const LandingHeader: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/80 backdrop-blur-lg border-b border-gray-200/50 py-3 shadow-sm' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="hover:opacity-90 transition-opacity">
            <Logo />
          </button>

          <nav className="hidden md:flex items-center gap-8">
            <a href="#problem" className="text-sm font-medium text-gray-600 hover:text-primary transition-colors">Problem</a>
            <a href="#solution" className="text-sm font-medium text-gray-600 hover:text-primary transition-colors">Solutions</a>
            <a href="#how-it-works" className="text-sm font-medium text-gray-600 hover:text-primary transition-colors">How it Works</a>
            <div className="h-4 w-px bg-gray-200 mx-2"></div>
            <Button variant="ghost" size="sm" className="text-gray-600 hover:text-primary" onClick={() => navigate('/login')}>Log In</Button>
            <Button size="sm" className="bg-primary hover:bg-primaryHover shadow-lg shadow-green-500/20" onClick={() => navigate('/signup')}>Get Started</Button>
          </nav>

          <div className="md:hidden">
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-600 hover:text-gray-900 p-2"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white border-b border-gray-100 shadow-lg p-4 flex flex-col gap-4 animate-in slide-in-from-top-5 duration-200">
          <a href="#problem" className="text-base font-medium text-gray-600 p-2 hover:bg-gray-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)}>Problem</a>
          <a href="#solution" className="text-base font-medium text-gray-600 p-2 hover:bg-gray-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)}>Solutions</a>
          <a href="#how-it-works" className="text-base font-medium text-gray-600 p-2 hover:bg-gray-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)}>How it Works</a>
          <div className="flex flex-col gap-2 pt-2 border-t border-gray-100">
            <Button variant="outline" className="w-full justify-center" onClick={() => navigate('/login')}>Log In</Button>
            <Button className="w-full justify-center" onClick={() => navigate('/signup')}>Get Started</Button>
          </div>
        </div>
      )}
    </header>
  );
};
